import { FC } from 'react';
import { Img } from 'react-image';
import Spinner from './Spinner';
import styled from '@emotion/styled';

type ImageProps = {
  src: string | null | undefined;
  fallback?: string;
  width?: number;
  height?: number;
  radius?: number | 'circle';
  className?: string;
  style?: React.CSSProperties;
};

const Image: FC<ImageProps> = ({
  src,
  fallback,
  width,
  height,
  radius = 3,
  className = '',
  style
}) => {
  return (
    <Container
      className={`d-inline-flex align-items-center justify-content-center bg-white rounded-${radius} ${className}`}
      style={style}
    >
      <Img
        width={width}
        height={height}
        src={src && fallback ? [src, fallback] : src ? src : (fallback ?? '')}
        loader={<Spinner size={width} />}
      />
    </Container>
  );
};

const Container = styled.div`
  overflow: hidden;
  box-shadow: -2px 4px 14px 0 rgba(0, 0, 0, 0.05);

  > img {
    object-fit: contain;
  }
`;

export default Image;
